import React from 'react';
import ApiKey from '@/features/settings/components/ApiKey.jsx';

export const VENDOR_PROVIDERS = [
    {
        value: 'openai',
        label: 'Open AI',
        title: 'OpenAI API Keys',
        descriptionPrefix:
            'Add your OpenAI API keys to use with SpecificAI. Multiple keys are used with automatic load balancing.',
        docsUrl: 'https://platform.openai.com/api-keys',
        docsQuestion: 'Need an OpenAI API key?',
        placeholder: 'Enter your OpenAI key',
        providerDisplayName: 'OpenAI',
    },
    {
        value: 'anthropic',
        label: 'Anthropic',
        title: 'Anthropic API Keys',
        descriptionPrefix:
            'Add your Anthropic API keys to use with SpecificAI. Multiple keys are used with automatic load balancing.',
        docsUrl: 'https://console.anthropic.com/settings/keys',
        docsQuestion: 'Need an Anthropic API key?',
        placeholder: 'Enter your Anthropic key',
        providerDisplayName: 'Anthropic',
    },
    {
        value: 'google',
        label: 'Google',
        title: 'Google API Keys',
        descriptionPrefix:
            'Add your Google AI Studio API keys to use with SpecificAI. Multiple keys are used with automatic load balancing.',
        docsUrl: 'https://aistudio.google.com/apikey',
        docsQuestion: 'Need a Google API key?',
        placeholder: 'Enter your Google key',
        providerDisplayName: 'Google',
    },
    {
        value: 'deepseek',
        label: 'DeepSeek',
        title: 'DeepSeek API Keys',
        descriptionPrefix:
            'Add your DeepSeek API keys to use with SpecificAI. Multiple keys are used with automatic load balancing.',
        docsUrl: 'https://platform.deepseek.com/api_keys',
        docsQuestion: 'Need a DeepSeek API key?',
        placeholder: 'Enter your DeepSeek key',
        providerDisplayName: 'DeepSeek',
    },
    {
        value: 'jev',
        label: 'TypeSafe AI',
        title: 'TypeSafe AI API Keys',
        descriptionPrefix:
            'Add your TypeSafe AI API keys to label and evaluate classification tasks with Jev, ' +
            'a System One decision model that returns per-label probabilities and confidence. ' +
            'Classification tasks only. Multiple keys are used with automatic load balancing.',
        docsUrl: 'https://console.typesafe.ai',
        docsQuestion: 'Need a TypeSafe AI API key?',
        placeholder: 'Enter your TypeSafe AI key',
        providerDisplayName: 'TypeSafe AI',
    },
];

const VendorKeysForm = ({
    provider,
    apiKeys,
    onKeysUpdate,
    recommendedProvider,
    onRecommendedProviderUpdate,
    onDraftStateChange,
    submitDraftRef,
}) => {
    const meta = VENDOR_PROVIDERS.find((p) => p.value === provider);
    if (!meta) return null;

    return (
        <ApiKey
            apiKeys={apiKeys}
            onKeysUpdate={onKeysUpdate}
            provider={provider}
            title={meta.title}
            descriptionPrefix={meta.descriptionPrefix}
            docsUrl={meta.docsUrl}
            docsQuestion={meta.docsQuestion}
            placeholder={meta.placeholder}
            providerDisplayName={meta.providerDisplayName}
            recommendedProvider={recommendedProvider}
            onRecommendedProviderUpdate={onRecommendedProviderUpdate}
            onDraftStateChange={onDraftStateChange}
            submitDraftRef={submitDraftRef}
        />
    );
};

export default VendorKeysForm;
